



































































import {
  Component,
  Prop,
  Watch,
  Vue,
  Emit
} from 'vue-property-decorator';

import {
  GatewayServiceProxy,
  GatewaySimServiceProxy,
  IotAppServiceProxy
} from "@/service-proxies/app-v2/iot-console.service-proxies";

import {
  MachineIotServiceProxy,
} from '@/service-proxies/app-v2/workStation.service-proxies'

import {
  DeviceServiceProxy as ExtranetDeviceV1Proxy
} 
from '@/service-proxies/app-v2/extranet.service-proxies'

import {
  DeviceServiceProxy as ExtranetDeviceV2Proxy
} 
from '@/service-proxies/app-v2/iot-extranet.service-proxies'

import { TenantAppServiceProxy } from "@/service-proxies/app-v2/system.service-proxies";

import { displayHardwareType } from "@/views/console/gateway-list/components/data";
import dayjs from 'dayjs';

const gatewatyServProxy = new GatewayServiceProxy()
const appServProxy = new IotAppServiceProxy()
const machineIotServProxy = new MachineIotServiceProxy()

const deviceV1Proxy = new ExtranetDeviceV1Proxy()
const deviceV2Proxy = new ExtranetDeviceV2Proxy()

const tasp = new TenantAppServiceProxy()
const simProxy = new GatewaySimServiceProxy()

@Component({
  components: {

  },
})
export default class GatewayDetail extends Vue {

  @Prop({ default: ()=> null }) 
  gatewayId: string;

  @Prop({ default: ()=> ({}) }) 
  gateway: any;

  @Watch("gatewayId")
  gatewayChange(newValue, oldValue) {
    this._iccid = undefined;
    this._imei = undefined;
    this.init();
  }

  _iccid: string = undefined;
  _imei: string = undefined;

  public spin: boolean = false;
  public disabled: boolean = false;
  public appList: any[]= [];
  public bindInfoList: any[]=[];
  public v1state: any= {}
  public v2state: any= {}
  public appMap: any[] = [];
  

  public hardwareType=displayHardwareType;


  public get iccid(){
    if(this._iccid){
      return this._iccid;
    }
    return this.gateway?.iccid || '--';
  }

  public get imei(){
    if(this._imei){
      return this._imei;
    }
    return this.gateway?.imei || '--';
  }

  public get acquisitionStatus(){
    const app = this.appList.find(c=>c.code!==0);
    return app?.isOnline || false;
  }

  public get bindDate(){
    console.log('this.bindInfoList',this.bindInfoList)
    return this.bindInfoList
      .map(c=>c.bindDatetime)
      .filter(c=>c)
      .map(c=>dayjs(c).format('YYYY-MM-DD HH:mm:ss'))
      .join(',')
  }

  public get bindDevice(){
    return this.bindInfoList
      .filter(c=>c.workStationCode)
      .filter(c=>c.workStationName)
      .map(c=>`${c.workStationCode}(${c.workStationName})`)
      .join(',')
  }

  public get customerAddress(){
    return this.bindInfoList
      .map(c=>c.customerAddress)
      .join(',')
  }

  public get customerName(){
    return this.bindInfoList
      .map(c=>c.customerName)
      .join(',')
  }

  public get isNotReady(){
    return this.isState('notready');
  }

  public get isReady(){
    return this.isState('ready');
  }

  public get isWorking(){
    return this.isState('working');
  }

  public get displayExtranetState(){
    if(this.isReady){
      return '就绪'
    }
    if(this.isWorking){
      return '工作中'
    }
    return '未就绪';
  }

  beforeCreate() {
  }
  beforeDestroy() {
  }

  public mounted() {
    this.init();
    
  }

  public init(){
    if(!this.gatewayId){
      return
    }
    this.getAppList();
    this.getGatewayBindInfo();
    this.getExtranetState();
  }

  public refreshSimIccid() {
    if(!this.gateway){
      return
    }
    if (!this.gateway.isOnline) {
      this.$message.error("网关不在线")
      return
    }
    if (!this.gateway.id) {
      return
    }
    this.spin = true
    this.disabled = true
    simProxy.refreshGatewayIccid(this.gateway.id).then((res) => {
      if (res) {
        if(res === "调用失败, APP不在线"){
          this.$message.error(res)
          return
        }
        this._iccid = res
      }
    }).finally(() => {
      this.spin = false
      this.disabled = false
    })
  }

  public refreshSimImei() {
    if(!this.gateway){
      return
    }
    if (!this.gateway.isOnline) {
      this.$message.error("网关不在线")
      return
    }
    if (!this.gateway.id) {
      return
    }
    this.spin = true
    this.disabled = true
    simProxy.refreshGatewayImei(this.gateway.id).then((res) => {
      if (res) {
        if(res === "调用失败, APP不在线"){
          this.$message.error(res)
          return
        }
        this._imei = res
      }
    }).finally(() => {
      this.spin = false
      this.disabled = false
    })
  }

  public async getAppList() {
      this.appList = []
      
      try {
        let { items } = await appServProxy.getIotAppList(undefined, this.gateway.code, undefined)
        this.appList = items
      } catch (e) {
        console.log(e)
      }
  }

  public getGatewayBindInfo(){
    machineIotServProxy
      .getGatewayBindInfoList(this.gateway.code)
      .then(res=>{
        this.bindInfoList = res;
      })
  }

  public getExtranetState(){
    deviceV1Proxy.findDeviceExtranetState(this.gateway.code)
      .then(res=>{
        this.v1state = res;
      })

    deviceV2Proxy.findDeviceExtranetState(this.gateway.code)
      .then(res=>{
        this.v2state = res;
      })
  }

  public async openCustomer(name){
      
    const data = await this.$store.dispatch('permission/generateRoutes', 'ops')

    this.$store.commit('permission/SET_ROUTES', data)
    const app = this.appMap.find((res) => res.appCode === 'ops')

    if (app) {
      this.$store.commit('permission/SET_APP_ROUTE_MAP', {
        appCode: app.appCode,
        appName: app.appName,
        routes: data.length ? data[0].children : []
      })

    }
    this.$router.addRoutes(
      data.concat({
        path: '*',
        redirect: '/404'
      })
    )
    await this.$router.push({
      path: '/ops/customer',
      query: {
        keyWord: name,
      }
    })
  }

  async initApp() {
      
    const appList = await tasp.getCurrentTenantGrantAPPList(1)

    this.appMap = appList


  }

  isState(stateName){
    if(this.v1state && this.v1state.exist){
      if(this.v1state.state===stateName){
        return true
      }
      return false;
    }
    
    if(this.v2state && this.v2state.exist){
      
      if(this.v2state.states===stateName){
        return true
      }
      return false;
    }

    return stateName==='notready';
  }


}
